import { render } from "./BulkSubmitOverlay.vue?vue&type=template&id=42cf1bd0"
import script from "./BulkSubmitOverlay.vue?vue&type=script&lang=js"
export * from "./BulkSubmitOverlay.vue?vue&type=script&lang=js"

import "./BulkSubmitOverlay.vue?vue&type=style&index=0&id=42cf1bd0&lang=scss"
script.render = render

export default script